<template>
<div class="wrapper">
  <signup-form />
  <decoration class="hide-in-mobile" />
 </div>
</template>

<script>
import SignupForm from "@/components/steps/signup/Form";
import Decoration from "@/components/steps/signup/Decoration";

export default {
  name: "Signup",
  components: {
    SignupForm,
    Decoration,
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";
.wrapper {
  min-height: 100vh;
  background: transparent linear-gradient(180deg, #FDFBFA 0%, #FBF5F3 72%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
  padding: 80px 0 108px;

  @include mobile {
    background: transparent linear-gradient(180deg, #FCFAF9 0%, #FFFFFF 49%, #FAF4F2 100%) 0% 0% no-repeat padding-box;
  }
}
</style>